// import { useState, useEffect, useContext } from "react";
// import MainLayouts from "../../../Layout/MainLayouts";
// import { ReactComponent as Trash } from "bootstrap-icons/icons/trash3.svg";
// import { ReactComponent as PlusSquareFill } from "bootstrap-icons/icons/plus-square-fill.svg";
// import { ReactComponent as PencilSquare } from "bootstrap-icons/icons/pencil-square.svg";
// import { ReactComponent as Eye } from "bootstrap-icons/icons/eye.svg";
// import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
// import { ReactComponent as CashStack } from "bootstrap-icons/icons/cash-stack.svg";
// import { ReactComponent as CardList } from "bootstrap-icons/icons/card-list.svg";
// import { ReactComponent as CardHeading } from "bootstrap-icons/icons/card-heading.svg";
// import { ReactComponent as List } from "bootstrap-icons/icons/list.svg";
// import Spinner from "../../spinner/Spinner";
// import { Link, useNavigate } from "react-router-dom";
// import axios from "axios";
// import ApiServices from "../../../api/ApiServices";
// import { toast } from "react-toastify";
// import DataTable from "react-data-table-component";
// import Swal from "sweetalert2";
// import CustomStyles from "../../../components/utils/CustomStyles";
// import CurrencyFormatter from "../../../components/utils/CurrencyFormatter";
// import { handleError } from "../../../components/utils/AuthenticationCheck";
// import AxiosApiCall from "../../../api/AxiosApiCall";
// import { AuthContext } from "../../../AuthProvider/AuthProvider";
// import formatDate from "../../../components/utils/DateFormatter";

// const GetAllPurchase = () => {
//     const [purchases, setPurchases] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [filterText, setFilterText] = useState("");
//     const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
//     const [confirmationLoading, setConfirmationLoading] = useState(false);
//     const { permissions } = useContext(AuthContext);
//     // console.log("all permission", permissions);
//     const [updatingIncentive, setUpdatingIncentive] = useState(false);
//     const [branchOpe, setBranchOpe] = useState([]);
//     const [isFilterVisible, setIsFilterVisible] = useState(false);
//     const [filterLoading, setFilterLoading] = useState(false);
//     const [clearFilterLoading, setClearFilterLoading] = useState(false);

//     const [filters, setFilters] = useState({
//         per_page: 20,
//         page: 1,
//         branch_id: "", // selected branch
//         approval_status: "", // pending | approved | rejected | cancelled
//         delivery_status: "", // pending | processing | delivered
//         start_date: "",
//         end_date: "",
//         search: "",
//     });

//     const [pagination, setPagination] = useState({
//         total: 0,
//         currentPage: 1,
//         perPage: 20,
//     });

//     const [summary, setSummary] = useState({
//         total_purchases: 0,
//         pending_approval: 0,
//         approved: 0,
//         rejected: 0,
//         cancelled: 0,
//         total_amount: 0,
//         pending_amount: 0,
//     });

//     const navigate = useNavigate();
//     // const axios = AxiosApiCall();

//     const fetchAllbranchList = async () => {
//         setLoading(true);
//         try {
//             const authData = JSON.parse(localStorage.getItem("auth"));
//             const token = authData?.token;
//             // console.log("this is the token from branch", token);
//             if (!token) {
//                 throw new Error("No access token found.");
//             }
//             const response = await axios.get(ApiServices.getAllBranchOperations, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     "Content-Type": "application/json",
//                 },
//                 withCredentials: true,
//             });

//             const { status, message, data } = response.data;
//             // console.log("this is all branch opeartions list", data);

//             if (status === 200) {
//                 const sortedData = data
//                     .slice()
//                     .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

//                 setBranchOpe(sortedData);
//                 toast.success(message, { toastId: "product-fetch-success" });
//             } else {
//                 handleError({ response: { status, data: { message } } }, navigate);
//             }
//         } catch (error) {
//             handleError(error, navigate);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const fetchAllPurchaseItem = async (filterPayload = filters) => {
//         setLoading(true);
//         try {
//             const authData = JSON.parse(localStorage.getItem("auth"));
//             const token = authData?.token;
//             if (!token) throw new Error("No access token found.");

//             const response = await axios.get(ApiServices.getAllPurchaseItem, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     "Content-Type": "application/json",
//                 },
//                 params: filterPayload,
//                 withCredentials: true,
//             });

//             const { status, message, data } = response.data;


//             if (status === 200 && data) {
//                 const purchasesData = data.purchases || [];
//                 const summaryData = data.summary || {};

//                 // Sort purchases by latest date
//                 const sortedPurchases = [...purchasesData].sort((a, b) =>
//                     new Date(b.purchase_date || b.created_at) - new Date(a.purchase_date || a.created_at)
//                 );

//                 const formattedSummary = {
//                     total_purchases: parseInt(summaryData.total_purchases) || 0,
//                     pending_approval: parseInt(summaryData.pending_approval) || 0,
//                     approved: parseInt(summaryData.approved) || 0,
//                     rejected: parseInt(summaryData.rejected) || 0,
//                     cancelled: parseInt(summaryData.cancelled) || 0,
//                     total_amount: summaryData.total_amount || 0,
//                     pending_amount: summaryData.pending_amount || 0,
//                 };

//                 setPurchases(sortedPurchases);
//                 setSummary(formattedSummary);
//                 setPagination({
//                     total: data.total || 0,
//                     currentPage: data.current_page || 1,
//                     perPage: data.per_page || 20,
//                 });

//                 toast.success(message, { toastId: "purchases-fetch-success" });
//             } else {
//                 handleError({ response: { status, data: { message } } }, navigate);
//             }
//         } catch (error) {
//             handleError(error, navigate);
//         } finally {
//             setLoading(false);
//         }
//     };


//     useEffect(() => {
//         fetchAllbranchList();
//         fetchAllPurchaseItem();
//     }, []);

//     const isAnyFilterFilled = () => {
//         return Object.values(filters).some(
//             (value) => value !== "" && value !== null
//         );
//     };


//     const handleClearFilters = async () => {
//         const defaultFilters = {
//             per_page: 20,
//             page: 1,
//             branch_id: "",
//             approval_status: "",
//             delivery_status: "",
//             start_date: "",
//             end_date: "",
//             search: "",
//         };

//         setFilters(defaultFilters);
//         setClearFilterLoading(true);
//         await fetchAllPurchaseItem(defaultFilters);
//         setClearFilterLoading(false);
//     };



//     const handleFilterClick = async () => {
//         if (!isAnyFilterFilled()) return;
//         setFilterLoading(true);
//         await fetchAllPurchaseItem(filters);
//         setFilterLoading(false);
//     };

//     // Handle pagination
//     const handlePageChange = (page) => {
//         const newFilters = {
//             ...filters,
//             page: page
//         };
//         setFilters(newFilters);
//         fetchAllPurchaseItem(newFilters);
//     };

//     // Handle per page change
//     const handlePerRowsChange = async (newPerPage, page) => {
//         const newFilters = {
//             ...filters,
//             page: page,
//             per_page: newPerPage
//         };
//         setFilters(newFilters);
//         await fetchAllPurchaseItem(newFilters);
//     };



//     const ExpandableComponent = ({ data }) => {
//         const [currentPage, setCurrentPage] = useState(1);
//         const itemsPerPage = 5;

//         // Ensure we always have a valid items array
//         const items = Array.isArray(data?.items) ? data.items : [];
//         const totalItems = items.length;
//         const totalPages = Math.ceil(totalItems / itemsPerPage);

//         // Get items for current page
//         const paginatedItems = items.slice(
//             (currentPage - 1) * itemsPerPage,
//             currentPage * itemsPerPage
//         );

//         const handleNext = () => {
//             if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
//         };

//         const handlePrev = () => {
//             if (currentPage > 1) setCurrentPage((prev) => prev - 1);
//         };

//         // Reset to first page when new data comes in
//         useEffect(() => {
//             setCurrentPage(1);
//         }, [data]);

//         return (
//             <div className="p-4 bg-gray-100 rounded-lg shadow-sm">
//                 <h4 className="font-bold mb-3 text-darkGreen3">
//                     Items in this Purchase
//                 </h4>

//                 {totalItems === 0 ? (
//                     <p className="text-gray-500">No items found for this purchase.</p>
//                 ) : (
//                     <>
//                         <div className="overflow-x-auto">
//                             <table className="w-full text-sm text-left border-collapse">
//                                 <thead className="bg-darkGreen3 text-lGrey uppercase">
//                                     <tr>
//                                         <th className="px-4 py-2">No</th>
//                                         <th className="px-4 py-2">Product Name</th>
//                                         <th className="px-4 py-2">Category</th>
//                                         <th className="px-4 py-2">Quantity</th>
//                                         <th className="px-4 py-2">Unit Price</th>
//                                         <th className="px-4 py-2">Total</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {paginatedItems.map((item, index) => (
//                                         <tr
//                                             key={`${item.item_id}-${index}`}
//                                             className="border-b hover:bg-gray-50 transition-colors"
//                                         >
//                                             <td className="px-4 py-2 font-medium">
//                                                 {(currentPage - 1) * itemsPerPage + index + 1}
//                                             </td>
//                                             <td className="px-4 py-2">{item.product_name}</td>
//                                             <td className="px-4 py-2">{item.product_category}</td>
//                                             <td className="px-4 py-2">{item.quantity}</td>
//                                             <td className="px-4 py-2">
//                                                 ₦{CurrencyFormatter(item.unit_price)}
//                                             </td>
//                                             <td className="px-4 py-2">
//                                                 ₦{CurrencyFormatter(item.total_amount)}
//                                             </td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </table>
//                         </div>

//                         {/* Pagination controls */}
//                         {totalPages > 1 && (
//                             <div className="flex justify-start items-center mt-3">
//                                 <button
//                                     onClick={handlePrev}
//                                     disabled={currentPage === 1}
//                                     className="bg-black2 text-lGrey px-3 py-1 rounded hover:bg-orange1 disabled:opacity-50 mx-1"
//                                 >
//                                     Prev
//                                 </button>

//                                 {/* <span className="text-sm text-gray-700">
//                                     Page {currentPage} of {totalPages}
//                                 </span> */}

//                                 <button
//                                     onClick={handleNext}
//                                     disabled={currentPage === totalPages}
//                                     className="bg-black2 text-lGrey px-3 py-1 rounded hover:bg-orange1 disabled:opacity-50"
//                                 >
//                                     Next
//                                 </button>
//                             </div>
//                         )}
//                     </>
//                 )}
//             </div>
//         );
//     };


//     const columns = [
//         {
//             name: "Purchase Number",
//             selector: (row) =>
//                 row.purchase_number ? row.purchase_number : "NOT AVAILABLE",
//             width: "200px",
//             sortable: true,
//         },
//         {
//             name: "Branch",
//             selector: (row) =>
//                 row.branch_name ? row.branch_name.toUpperCase() : "NOT AVAILABLE",
//             sortable: true,
//             width: "200px",
//         },
//         {
//             name: "Total Amount",
//             selector: (row) => row.total_amount,
//             sortable: true,
//             cell: (row) => CurrencyFormatter(row.total_amount || 0),
//             width: "200px",
//         },
//         {
//             name: "Approval Status",
//             selector: (row) => row.approval_status,
//             sortable: true,
//             width: "200px",
//             cell: (row) => (
//                 <span
//                     className={
//                         row.approval_status === "pending"
//                             ? "text-orange1"
//                             : row.approval_status === "approved"
//                                 ? "text-green-600"
//                                 : "text-red-600"
//                     }
//                 >
//                     {row.approval_status.toUpperCase()}
//                 </span>
//             ),
//         },
//         {
//             name: "Delivery Status",
//             selector: (row) =>
//                 row.delivery_status ? row.delivery_status.toUpperCase() : "NOT AVAILABLE",
//             sortable: true,
//             width: "200px",
//         },
//         {
//             name: "Purchase Date",
//             selector: (row) =>
//                 formatDate(row.purchase_date) ? row.purchase_date : "NOT AVAILABLE",
//             width: "200px",
//             sortable: true,
//         },
//     ];

//     const filteredItems = purchases.filter((item) =>
//         Object.keys(item).some((key) =>
//             item[key]?.toString().toLowerCase().includes(filterText.toLowerCase())
//         )
//     );

//     const data = filteredItems.map((purchases) => ({
//         reference: purchases.reference || "NOT AVAILABLE",
//         amount: purchases.amount || "NOT AVAILABLE",
//         description: purchases.description,
//         status: purchases.status,
//         created_at: purchases.created_at,
//     }));



//     return (
//         <MainLayouts>
//             <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
//                 <section
//                     className="w-full pr-[3%] pt-3 my-3"
//                     style={{ backgroundColor: "#F7F7F7" }}
//                 >
//                     <nav className="bg-gray-200 py-0 px-4 rounded-lg">
//                         <ol className="list-none p-0 inline-flex mb-2">
//                             <li className="flex items-center">
//                                 <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
//                                     Operations
//                                 </p>
//                                 <ChevronRightIcon />
//                             </li>
//                             <li className="flex items-center">
//                                 <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
//                                     Purchase Stock
//                                 </p>
//                                 <ChevronRightIcon />
//                             </li>
//                             <li className="flex items-center">
//                                 <p className="text-orange1">Item</p>
//                             </li>
//                         </ol>
//                     </nav>
//                 </section>
//                 <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
//                     <div className="p-4 bg-blue-100 rounded-lg shadow-md">
//                         <div className="font-bold text-xl">
//                             {summary.total_purchases || 0}
//                         </div>
//                         <div className="text-sm text-darkGreen3">Total Purchases</div>
//                     </div>
//                     <div className="p-4 bg-yellow-100 rounded-lg shadow-md">
//                         <div className="font-bold text-xl">
//                             {summary.pending_approval || 0}
//                         </div>
//                         <div className="text-sm text-darkGreen3">Pending</div>
//                     </div>
//                     <div className="p-4 bg-green-100 rounded-lg shadow-md">
//                         <div className="font-bold text-xl">{summary.approved || 0}</div>
//                         <div className="text-sm text-darkGreen3">Approved</div>
//                     </div>
//                     <div className="p-4 bg-green-100 rounded-lg shadow-md">
//                         <div className="font-bold text-xl">{summary.cancelled || 0}</div>
//                         <div className="text-sm text-darkGreen3">Cancelled</div>
//                     </div>
//                     <div className="p-4 bg-red-100 rounded-lg shadow-md">
//                         <div className="font-bold text-xl">{summary.rejected || 0}</div>
//                         <div className="text-sm text-darkGreen3">Rejected</div>
//                     </div>
//                     <div className="p-4 bg-gray-200 rounded-lg shadow-md">
//                         <div className="font-bold text-xl">
//                             {CurrencyFormatter(summary.total_amount || 0)}
//                         </div>
//                         <div className="text-sm text-darkGreen3">Total Amount</div>
//                     </div>
//                     <div className="p-4 bg-orange-100 rounded-lg shadow-md">
//                         <div className="font-bold text-xl">
//                             {CurrencyFormatter(summary.pending_amount || 0)}
//                         </div>
//                         <div className="text-sm text-darkGreen3">Pending Amount</div>
//                     </div>
//                 </div>

//                 <div className="pb-4 bg-white dark:bg-gray-900 flex flex-wrap justify-between">
//                     {/* <div className="relative w-full sm:w-1/2 mb-4 sm:mb-0">
//             <input
//               type="search"
//               className="block w-full px-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50"
//               placeholder="Search"
//               value={filterText}
//               onChange={handleFilter}
//             />
//           </div> */}
//                     <div className="flex flex-wrap gap-3 mb-4">
//                         {/* Branch Dropdown */}
//                         <select
//                             className="border rounded px-3 py-2 border-lGrey"
//                             value={filters.branch_id}
//                             onChange={(e) =>
//                                 setFilters({ ...filters, branch_id: e.target.value })
//                             }
//                         >
//                             <option value="">All Branches</option>
//                             {branchOpe.map((branch) => (
//                                 <option key={branch.id} value={branch.id}>
//                                     {branch.name}
//                                 </option>
//                             ))}
//                         </select>

//                         {/* Approval Status */}
//                         <select
//                             className="border rounded px-3 py-2 border-lGrey"
//                             value={filters.approval_status}
//                             onChange={(e) =>
//                                 setFilters({ ...filters, approval_status: e.target.value })
//                             }
//                         >
//                             <option value="">All Status</option>
//                             <option value="pending">Pending</option>
//                             <option value="approved">Approved</option>
//                             <option value="rejected">Rejected</option>
//                             <option value="cancelled">Cancelled</option>
//                         </select>

//                         {/* Delivery Status */}
//                         <select
//                             className="border rounded px-3 py-2 border-lGrey"
//                             value={filters.delivery_status}
//                             onChange={(e) =>
//                                 setFilters({ ...filters, delivery_status: e.target.value })
//                             }
//                         >
//                             <option value="">All Delivery</option>
//                             <option value="pending">Pending</option>
//                             <option value="processing">Processing</option>
//                             <option value="delivered">Delivered</option>
//                         </select>

//                         {/* Start & End Dates */}
//                         <input
//                             type="date"
//                             value={filters.start_date}
//                             onChange={(e) =>
//                                 setFilters({ ...filters, start_date: e.target.value })
//                             }
//                             className="border rounded px-3 py-2 border-lGrey"
//                         />
//                         <input
//                             type="date"
//                             value={filters.end_date}
//                             onChange={(e) =>
//                                 setFilters({ ...filters, end_date: e.target.value })
//                             }
//                             className="border rounded px-3 py-2 border-lGrey"
//                         />

//                         {/* Search */}
//                         <input
//                             type="text"
//                             placeholder="Search by purchase number"
//                             value={filters.search}
//                             onChange={(e) =>
//                                 setFilters({ ...filters, search: e.target.value })
//                             }
//                             className="border rounded px-3 py-2 border-lGrey"
//                         />

//                         {/* Submit Button */}
//                         {/* Filter Button - Disabled until user enters a value */}
//                         <button
//                             onClick={handleFilterClick}
//                             className="bg-darkGreen3 text-lGrey px-4 py-2 rounded disabled:opacity-50 disabled:cursor-not-allowed"
//                             disabled={!isAnyFilterFilled() || filterLoading}
//                         >
//                             {filterLoading ? "Filtering..." : "Filter"}
//                         </button>

//                         {/* Clear Filters Button */}
//                         {isAnyFilterFilled() && (
//                             <button
//                                 onClick={handleClearFilters}
//                                 className="bg-orange1 text-lGrey px-4 py-2 rounded hover:bg-orange1 transition-colors"
//                                 disabled={clearFilterLoading}
//                             >
//                                 {clearFilterLoading ? "Clearing..." : "Clear Filters"}
//                             </button>
//                         )}
//                     </div>
//                 </div>
//                 {loading ? (
//                     <Spinner />
//                 ) : (
//                     <DataTable
//                         columns={columns}
//                         data={purchases}
//                         pagination
//                         highlightOnHover
//                         striped
//                         customStyles={CustomStyles}
//                         noDataComponent={<div>No Purchase found</div>}
//                         expandableRows
//                         expandableRowsComponent={(props) => (
//                             <ExpandableComponent data={props.data} />
//                         )}
//                     />
//                 )}
//             </div>
//         </MainLayouts>
//     );
// };

// export default GetAllPurchase;





import { useState, useContext, useEffect } from "react";
import MainLayouts from "../../../Layout/MainLayouts";
import { ReactComponent as Trash } from "bootstrap-icons/icons/trash3.svg";
import { ReactComponent as PlusSquareFill } from "bootstrap-icons/icons/plus-square-fill.svg";
import { ReactComponent as PencilSquare } from "bootstrap-icons/icons/pencil-square.svg";
import { ReactComponent as Eye } from "bootstrap-icons/icons/eye.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as CashStack } from "bootstrap-icons/icons/cash-stack.svg";
import { ReactComponent as CardList } from "bootstrap-icons/icons/card-list.svg";
import { ReactComponent as CardHeading } from "bootstrap-icons/icons/card-heading.svg";
import { ReactComponent as List } from "bootstrap-icons/icons/list.svg";
import { ReactComponent as Download } from "bootstrap-icons/icons/download.svg";
import { ReactComponent as ArrowClockwise } from "bootstrap-icons/icons/arrow-clockwise.svg";
import Spinner from "../../spinner/Spinner";
import { Link, useNavigate } from "react-router-dom";
import ApiServices from "../../../api/ApiServices";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import CustomStyles from "../../../components/utils/CustomStyles";
import CurrencyFormatter from "../../../components/utils/CurrencyFormatter";
import { handleError } from "../../../components/utils/AuthenticationCheck";
import { AuthContext } from "../../../AuthProvider/AuthProvider";
import formatDate from "../../../components/utils/DateFormatter";
import { downloadCSVFromApi } from "../../../components/utils/DownlaodCSVFromApi";
import { useAllPurchases, useBranches } from "../../../hooks/useAppData";

const GetAllPurchase = () => {
    const [loadingCSV, setLoadingCSV] = useState(false);
    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [confirmationLoading, setConfirmationLoading] = useState(false);
    const { permissions } = useContext(AuthContext);
    const [filterLoading, setFilterLoading] = useState(false);
    const [clearFilterLoading, setClearFilterLoading] = useState(false);

    const [filters, setFilters] = useState({
        per_page: 20,
        page: 1,
        branch_id: "",
        approval_status: "",
        delivery_status: "",
        start_date: "",
        end_date: "",
        search: "",
    });

    const navigate = useNavigate();

    const { data: branchesResponse } = useBranches();
    const branchOpe = (branchesResponse?.data || []).slice().sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

    const { data: purchasesResponse, isLoading: loading } = useAllPurchases(filters);
    const purchasesData = purchasesResponse?.data?.purchases || [];
    const purchases = [...purchasesData].sort((a, b) =>
        new Date(b.purchase_date || b.created_at) - new Date(a.purchase_date || a.created_at)
    );
    const summaryData = purchasesResponse?.data?.summary || {};
    const summary = {
        total_purchases: parseInt(summaryData.total_purchases) || 0,
        pending_approval: parseInt(summaryData.pending_approval) || 0,
        approved: parseInt(summaryData.approved) || 0,
        rejected: parseInt(summaryData.rejected) || 0,
        cancelled: parseInt(summaryData.cancelled) || 0,
        total_amount: summaryData.total_amount || 0,
        pending_amount: summaryData.pending_amount || 0,
    };
    const pagination = {
        total: purchasesResponse?.data?.total || 0,
        currentPage: purchasesResponse?.data?.current_page || 1,
        perPage: purchasesResponse?.data?.per_page || 20,
    };

    // Check if both dates are selected for CSV download
    const areDatesSelected = filters.start_date && filters.end_date;

    // Handle CSV Download - Server-side filtered by date
    const handleDownloadCSV = async () => {
        if (!areDatesSelected) {
            toast.error("Please select both start and end dates to download CSV");
            return;
        }

        // Validate date range
        const startDate = new Date(filters.start_date);
        const endDate = new Date(filters.end_date);

        if (startDate > endDate) {
            toast.error("Start date must be before end date");
            return;
        }

        // Limit date range to a year
        const daysDiff = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));
        if (daysDiff > 365) {
            toast.error("Date range cannot exceed 1 year");
            return;
        }

        setLoadingCSV(true);

        try {
            const authData = JSON.parse(localStorage.getItem("auth"));
            const token = authData?.token;

            if (!token) {
                toast.error("No access token found");
                return;
            }

            // Prepare download payload 
            const downloadPayload = {
                start_date: filters.start_date,
                end_date: filters.end_date,
                download: 1,
            };

            // Create filename with date range
            const startDateFormatted = filters.start_date.replace(/-/g, '_');
            const endDateFormatted = filters.end_date.replace(/-/g, '_');
            const filename = `purchases_${startDateFormatted}_to_${endDateFormatted}.csv`;

            // Call the download function
            await downloadCSVFromApi(
                ApiServices.getAllPurchaseItem,
                downloadPayload,
                token,
                {
                    filename: filename,
                    columnsToRemove: [], // Add sensitive columns to exclude 
                    maxRows: 50000
                }
            );

        } catch (error) {
            // console.error("Download error:", error);
            handleError(error, navigate);
            // Additional download-specific error messages
            if (error.message && error.message.includes("CSV")) {
                toast.error("Failed to process CSV file");
            } else if (error.message && error.message.includes("network")) {
                toast.error("Network error during download");
            }
        } finally {
            setLoadingCSV(false);
        }
    };

    const isAnyFilterFilled = () => {
        return Object.values(filters).some(
            (value) => value !== "" && value !== null && value !== 20 && value !== 1
        );
    };

    const handleClearFilters = () => {
        setClearFilterLoading(true);
        setFilters({
            per_page: 20,
            page: 1,
            branch_id: "",
            approval_status: "",
            delivery_status: "",
            start_date: "",
            end_date: "",
            search: "",
        });
        setClearFilterLoading(false);
    };

    const handleFilterClick = () => {
        if (!isAnyFilterFilled()) return;
        // React Query auto re-fetches when filters state changes
    };

    const handlePageChange = (page) => {
        setFilters(prev => ({ ...prev, page }));
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setFilters(prev => ({ ...prev, page, per_page: newPerPage }));
    };

    // Filter data based on search text AND date range
    const filteredItems = purchases.filter((item) => {
        // Filter by search text
        const matchesFilterText = Object.values(item).some(
            (value) =>
                typeof value === "string" &&
                value.toLowerCase().includes(filters.search.toLowerCase())
        );

        // Filter data based on date range
        let matchesDateRange = true;
        if (areDatesSelected) {
            const itemDate = new Date(item.purchase_date || item.created_at);
            const startDate = new Date(filters.start_date);
            const endDate = new Date(filters.end_date);

            // Set time to end of day for end date
            // 23: Hours(24 - hour format) = 11:00 PM
            // 59: Minutes = 59 minutes past the hour
            // 59: Seconds = 59 seconds past the minute
            // 999: Milliseconds = 999 milliseconds past the second
            endDate.setHours(23, 59, 59, 999);

            matchesDateRange = itemDate >= startDate && itemDate <= endDate;
        }

        return matchesFilterText && matchesDateRange;
    });

    const ExpandableComponent = ({ data }) => {
        const [currentPage, setCurrentPage] = useState(1);
        const itemsPerPage = 5;

        const items = Array.isArray(data?.items) ? data.items : [];
        const totalItems = items.length;
        const totalPages = Math.ceil(totalItems / itemsPerPage);

        const paginatedItems = items.slice(
            (currentPage - 1) * itemsPerPage,
            currentPage * itemsPerPage
        );

        const handleNext = () => {
            if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
        };

        const handlePrev = () => {
            if (currentPage > 1) setCurrentPage((prev) => prev - 1);
        };

        useEffect(() => {
            setCurrentPage(1);
        }, [data]);

        return (
            <div className="p-4 bg-gray-100 rounded-lg shadow-sm">
                <h4 className="font-bold mb-3 text-darkGreen3">
                    Items in this Purchase
                </h4>

                {totalItems === 0 ? (
                    <p className="text-gray-500">No items found for this purchase.</p>
                ) : (
                    <>
                        <div className="overflow-x-auto">
                            <table className="w-full text-sm text-left border-collapse">
                                <thead className="bg-darkGreen3 text-lGrey uppercase">
                                    <tr>
                                        <th className="px-4 py-2">No</th>
                                        <th className="px-4 py-2">Product Name</th>
                                        <th className="px-4 py-2">Category</th>
                                        <th className="px-4 py-2">Quantity</th>
                                        <th className="px-4 py-2">Unit Price</th>
                                        <th className="px-4 py-2">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {paginatedItems.map((item, index) => (
                                        <tr
                                            key={`${item.item_id}-${index}`}
                                            className="border-b hover:bg-gray-50 transition-colors"
                                        >
                                            <td className="px-4 py-2 font-medium">
                                                {(currentPage - 1) * itemsPerPage + index + 1}
                                            </td>
                                            <td className="px-4 py-2">{item.product_name}</td>
                                            <td className="px-4 py-2">{item.product_category}</td>
                                            <td className="px-4 py-2">{item.quantity}</td>
                                            <td className="px-4 py-2">
                                                ₦{CurrencyFormatter(item.unit_price)}
                                            </td>
                                            <td className="px-4 py-2">
                                                ₦{CurrencyFormatter(item.total_amount)}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Pagination controls */}
                        {totalPages > 1 && (
                            <div className="flex justify-start items-center mt-3">
                                <button
                                    onClick={handlePrev}
                                    disabled={currentPage === 1}
                                    className="bg-black2 text-lGrey px-3 py-1 rounded hover:bg-orange1 disabled:opacity-50 mx-1"
                                >
                                    Prev
                                </button>
                                <button
                                    onClick={handleNext}
                                    disabled={currentPage === totalPages}
                                    className="bg-black2 text-lGrey px-3 py-1 rounded hover:bg-orange1 disabled:opacity-50"
                                >
                                    Next
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
        );
    };

    const columns = [
        {
            name: "Purchase Number",
            selector: (row) =>
                row.purchase_number ? row.purchase_number : "NOT AVAILABLE",
            width: "200px",
            sortable: true,
        },
        {
            name: "Branch",
            selector: (row) =>
                row.branch_name ? row.branch_name.toUpperCase() : "NOT AVAILABLE",
            sortable: true,
            width: "200px",
        },
        {
            name: "Total Amount",
            selector: (row) => row.total_amount,
            sortable: true,
            cell: (row) => CurrencyFormatter(row.total_amount || 0),
            width: "200px",
        },
        {
            name: "Approval Status",
            selector: (row) => row.approval_status.toUpperCase(),
            sortable: true,
            width: "200px",
            cell: (row) => (
                <span
                    className={
                        row.approval_status === "pending"
                            ? "text-orange1"
                            : row.approval_status === "approved"
                                ? "text-darkGreen3"
                                : "text-dash3"
                    }
                >
                    {row.approval_status.toUpperCase()}
                </span>
            ),
        },
        // {
        //     name: "Delivery Status",
        //     selector: (row) =>
        //         row.delivery_status ? row.delivery_status.toUpperCase() : "NOT AVAILABLE",
        //     sortable: true,
        //     width: "200px",
        // },
        {
            name: "Purchase Date",
            selector: (row) =>
                row.purchase_date ? formatDate(row.purchase_date) : "NOT AVAILABLE",
            width: "200px",
            sortable: true,
        },
    ];


     const data = filteredItems.map((purchases) => ({
         reference: purchases.reference || "NOT AVAILABLE",
         amount: purchases.amount || "NOT AVAILABLE",
         description: purchases.description,
         status: purchases.status,
         created_at: purchases.created_at,
     }));

    return (
        <MainLayouts>
            <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
                <section
                    className="w-full pr-[3%] pt-3 my-3"
                    style={{ backgroundColor: "#F7F7F7" }}
                >
                    <nav className="bg-gray-200 py-0 px-4 rounded-lg">
                        <ol className="list-none p-0 inline-flex mb-2">
                            <li className="flex items-center">
                                <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                                    Operations
                                </p>
                                <ChevronRightIcon />
                            </li>
                            <li className="flex items-center">
                                <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                                    Purchase Stock
                                </p>
                                <ChevronRightIcon />
                            </li>
                            <li className="flex items-center">
                                <p className="text-orange1">Item</p>
                            </li>
                        </ol>
                    </nav>
                </section>

                <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
                    <div className="p-4 bg-blue-100 rounded-lg shadow-md">
                        <div className="font-bold text-xl">
                            {summary.total_purchases || 0}
                        </div>
                        <div className="text-sm text-darkGreen3">Total Purchases</div>
                    </div>
                    <div className="p-4 bg-yellow-100 rounded-lg shadow-md">
                        <div className="font-bold text-xl">
                            {summary.pending_approval || 0}
                        </div>
                        <div className="text-sm text-darkGreen3">Pending</div>
                    </div>
                    <div className="p-4 bg-green-100 rounded-lg shadow-md">
                        <div className="font-bold text-xl">{summary.approved || 0}</div>
                        <div className="text-sm text-darkGreen3">Approved</div>
                    </div>
                    <div className="p-4 bg-green-100 rounded-lg shadow-md">
                        <div className="font-bold text-xl">{summary.cancelled || 0}</div>
                        <div className="text-sm text-darkGreen3">Cancelled</div>
                    </div>
                    <div className="p-4 bg-red-100 rounded-lg shadow-md">
                        <div className="font-bold text-xl">{summary.rejected || 0}</div>
                        <div className="text-sm text-darkGreen3">Rejected</div>
                    </div>
                    <div className="p-4 bg-gray-200 rounded-lg shadow-md">
                        <div className="font-bold text-xl">
                            {CurrencyFormatter(summary.total_amount || 0)}
                        </div>
                        <div className="text-sm text-darkGreen3">Total Amount</div>
                    </div>
                    <div className="p-4 bg-orange-100 rounded-lg shadow-md">
                        <div className="font-bold text-xl">
                            {CurrencyFormatter(summary.pending_amount || 0)}
                        </div>
                        <div className="text-sm text-darkGreen3">Pending Amount</div>
                    </div>
                </div>

                {/* Filter Controls with Download Button */}
                <div className="pb-4 bg-white dark:bg-gray-900">
                    <div className="flex flex-wrap gap-3 mb-4">
                        {/* Branch Dropdown */}
                        <select
                            className="border rounded px-3 py-2 border-lGrey"
                            value={filters.branch_id}
                            onChange={(e) =>
                                setFilters({ ...filters, branch_id: e.target.value })
                            }
                        >
                            <option value="">All Branches</option>
                            {branchOpe.map((branch) => (
                                <option key={branch.id} value={branch.id}>
                                    {branch.name}
                                </option>
                            ))}
                        </select>

                        {/* Approval Status */}
                        <select
                            className="border rounded px-3 py-2 border-lGrey"
                            value={filters.approval_status}
                            onChange={(e) =>
                                setFilters({ ...filters, approval_status: e.target.value })
                            }
                        >
                            <option value="">All Status</option>
                            <option value="pending">Pending</option>
                            <option value="approved">Approved</option>
                            <option value="rejected">Rejected</option>
                            <option value="cancelled">Cancelled</option>
                        </select>

                        {/* Delivery Status */}
                        <select
                            className="border rounded px-3 py-2 border-lGrey"
                            value={filters.delivery_status}
                            onChange={(e) =>
                                setFilters({ ...filters, delivery_status: e.target.value })
                            }
                        >
                            <option value="">All Delivery</option>
                            <option value="pending">Pending</option>
                            <option value="processing">Processing</option>
                            <option value="delivered">Delivered</option>
                        </select>

                        {/* Start & End Dates */}
                        <input
                            type="date"
                            value={filters.start_date}
                            onChange={(e) =>
                                setFilters({ ...filters, start_date: e.target.value })
                            }
                            className="border rounded px-3 py-2 border-lGrey"
                            max={filters.end_date || undefined}
                        />
                        <input
                            type="date"
                            value={filters.end_date}
                            onChange={(e) =>
                                setFilters({ ...filters, end_date: e.target.value })
                            }
                            className="border rounded px-3 py-2 border-lGrey"
                            min={filters.start_date || undefined}
                        />

                        {/* Search */}
                        <input
                            type="text"
                            placeholder="Search by purchase number"
                            value={filters.search}
                            onChange={(e) =>
                                setFilters({ ...filters, search: e.target.value })
                            }
                            className="border rounded px-3 py-2 border-lGrey"
                        />

                        {/* Filter Button */}
                        <button
                            onClick={handleFilterClick}
                            className="bg-darkGreen3 text-lGrey px-4 py-2 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                            disabled={!isAnyFilterFilled() || filterLoading}
                        >
                            {filterLoading ? "Filtering..." : "Filter"}
                        </button>

                        {/* Clear Filters Button */}
                        {isAnyFilterFilled() && (
                            <button
                                onClick={handleClearFilters}
                                className="bg-black1 text-lGrey px-4 py-2 rounded hover:bg-orange1 transition-colors"
                                disabled={clearFilterLoading}
                            >
                                {clearFilterLoading ? "Clearing..." : "Clear Filters"}
                            </button>
                        )}

                        {/* Download CSV Button - Added here with other filters */}
                        <button
                            onClick={handleDownloadCSV}
                            className={`inline-flex justify-center items-center gap-x-2 px-4 py-2 rounded-md text-sm font-semibold transition-colors duration-200 ${areDatesSelected
                                ? "bg-orange1 text-lGrey3 hover:bg-orange-600 cursor-pointer"
                                : "bg-gray-300 text-gray-500 cursor-not-allowed"
                                }`}
                            disabled={!areDatesSelected || loadingCSV}
                            title={!areDatesSelected ? "Select start and end dates to enable download" : "Download CSV for selected date range"}
                        >
                            {loadingCSV ? (
                                <>
                                    <ArrowClockwise className="w-4 h-4 text-white animate-spin" />
                                    Downloading...
                                </>
                            ) : (
                                <>
                                    <Download className="w-4 h-4" />
                                    Download CSV
                                </>
                            )}
                        </button>
                    </div>

                    {/* Help text showing filtered results */}
                    {areDatesSelected && filteredItems.length > 0 && (
                        <div className="mt-2">
                            <p className="text-sm text-gray-600">
                                Showing {filteredItems.length} purchases from {filters.start_date} to {filters.end_date}
                            </p>
                           
                        </div>
                    )}
                    {areDatesSelected && filteredItems.length === 0 && (
                        <div className="mt-2">
                            <p className="text-sm text-orange1">
                                No purchases found for the selected date range ({filters.start_date} to {filters.end_date})
                            </p>
                        </div>
                    )}
                    {!areDatesSelected && (
                        <div className="mt-2">
                            <p className="text-xs text-gray-500">
                                Select start and end dates to filter records and enable CSV download
                            </p>
                        </div>
                    )}
                </div>

                {loading ? (
                    <Spinner />
                ) : (
                    <DataTable
                        columns={columns}
                        data={filteredItems}
                        pagination
                        highlightOnHover
                        striped
                        customStyles={CustomStyles}
                        noDataComponent={
                            <div className="py-8 text-center text-gray-500">
                                {areDatesSelected
                                    ? `No purchases found for ${filters.start_date} to ${filters.end_date}`
                                    : "No Purchase found"
                                }
                            </div>
                        }
                        expandableRows
                        expandableRowsComponent={(props) => (
                            <ExpandableComponent data={props.data} />
                        )}
                    />
                )}
            </div>
        </MainLayouts>
    );
};

export default GetAllPurchase;